import React, { useState, useEffect } from "react";
import Loading from "../functions/Loading";
import evaluarRespuestas from "../functions/EvaluarRespuestas";


//Importación de imagenes
import flexografiaImg from "../assets/test/ImpresionFlexografica.png";
import hibridaImg from "../assets/test/ImpresionDigitalHibrida.png";
import termoencogiblesImg from "../assets/test/MangasTermoencogibles.png";
import imlImg from "../assets/test/InMold.png";
import termoformadoraImg from "../assets/test/Termoformadora.png";

const preguntas = [
  {
    pregunta: "¿Qué tipo de producto necesitas etiquetar o personalizar?",
    opciones: [
      "Botellas o envases cilíndricos",
      "Vasos promocionales",
      "Empaque rígido (contenedores, bandejas)",
      "Producto variado (muchas versiones en tirajes pequeños)",
    ],
  },
  {
    pregunta: "¿Cuál es el volumen aproximado de tu pedido?",
    opciones: [
        "Más de 100,000 piezas (producción masiva)", 
        "Entre 10,000 y 100,000 piezas", 
        "Menos de 10,000 piezas", 
    ],
  },
  {
    pregunta: "¿Qué nivel de personalización necesitas?",
    opciones: [
        "Sí, con personalización o datos variables", 
        "No, todas iguales", 
    ],
  },
  {
    pregunta: "¿Buscas acabados especiales o efectos llamativos?",
    opciones: [
        "Sí (metalizados, holográficos, aroma, glow, etc.)", 
        "No, algo funcional y resistente", 
    ],
  },
  {
    pregunta: "¿Tu producto estará en contacto con alimentos o bebidas?",
    opciones: [
        "Sí, necesita material grado alimenticio", 
        "No, es para otro tipo de industria"
    ],
  },
];

// Contenido personalizado para cada resultado
const contenidoResultado = [
  {
    respuestacalc: "flexografia",
    tituloprincipal: "Impresión en Flexografía",
    subtitulo: "Ideal para grandes volúmenes, registro preciso y acabados especiales sin sacrificar velocidad.",
    texto1: "Te recomendamos:",
    texto2: "y nuestro especialista en Flexografía se pondrá en contacto contigo para revisar las especificaciones de tu diseño.",
    txtclick: [
      [<a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank">Da clic aquí </a>],
    ],
    imgrespuesta: flexografiaImg,
    link:'',
  },
  {
    respuestacalc: "digital",
    tituloprincipal: "Impresión Digital Híbrida",
    subtitulo: "Para tirajes pequeños y personalización masiva.",
    texto1: "Tu mejor opción es la:",
    texto2: "Da clic aquí y nuestro especialista en Impresión Digital Híbrida se pondrá en contacto contigo para aterrizar todos esos diseños que tienes en mente.",
    txtclick: [
      [<a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank">Da clic aquí </a>],
    ],
    imgrespuesta: hibridaImg,
    link:'',
  },
  {
    respuestacalc: "mangas",
    tituloprincipal: "Mangas Termoencogibles",
    subtitulo: "Para cubrir por completo tu producto y destacar en el anaquel, optimizando tiempo y reduciendo desperdicios.",
    texto1: "Te recomendamos:",
    texto2: "y nuestro experto en Mangas Termoencogibles te contactará para crear un diseño único para tu producto.",
    txtclick: [
      [<a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank">Da clic aquí </a>],
    ],
    imgrespuesta: termoencogiblesImg,
    link:'',
  },
  {
    respuestacalc: "iml",
    tituloprincipal: "Inyección con In Mold Labeling",
    subtitulo: "Diseño y resistencia integrados en vasos de 24 y 32 oz.",
    texto1: "Tu mejor opción es la:",
    texto2: "y nuestro experto en In Mold se pondrá en contacto contigo para ayudarte a definir la mejor opción de diseño para tu vaso.",
    txtclick: [
      [<a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank">Da clic aquí </a>],
    ],
    imgrespuesta: imlImg,
    link:'',
  },
  {
    respuestacalc: "termoformado",
    tituloprincipal: "Termoformado de Precisión con impresión In Mold",
    subtitulo: "Empaques rígidos con diseños únicos:\nsí son posibles.",
    texto1: "Lo que necesitas es:",
    texto2: "y nuestro especialista en Termoformado se pondrá en contacto contigo para entender a detalle lo que tu proyecto requiere.",
    txtclick: [
      [<a href="https://wa.link/9qu07v" rel="noopener noreferrer" aria-label="Chatea con nosotros por WhatsApp" target="_blank">Da clic aquí </a>],
    ],
    imgrespuesta: termoformadoraImg,
    link:'',
  },
];


function Test() {
  const [step, setStep] = useState(0); // 0 = pantalla inicial
  const [respuestas, setRespuestas] = useState(Array(preguntas.length).fill(null));
  const [loadingResultados, setLoadingResultados] = useState(true);

  const handleSelect = (index, opcion) => {
    const nuevas = [...respuestas];
    nuevas[index] = opcion;
    setRespuestas(nuevas);
  };

  const handleRestart = () => {
    setRespuestas(Array(preguntas.length).fill(null));
    setStep(0);
    //Agregado
    setLoadingResultados(false);
  };

  const handleWhatsApp = () => {
    const mensaje = respuestas
      .map((r, i) => `Pregunta ${i + 1}: ${r}`)
      .join("%0A");
    window.open(`https://wa.link/9qu07v`, "_blank");
  };
  {/**
    
    https://wa.me/2291828034?text=Hola!%20Estoy%20interesado%20en%20realizar%20un%20pedido,%20comparto%20mis%20respuestas%20al%20formulario:%0A${mensaje}%0AQuedo%20pendiente%20a%20su%20seguimiento.`, "_blank"
    
    */}

  // Cuando llegamos a resultados, activamos loader
  useEffect(() => {
    if (step === preguntas.length + 1) {
      setLoadingResultados(true);
      const timer = setTimeout(() => {
        setLoadingResultados(false);
      }, 5000); // 5000 segundos (ajusta aquí el tiempo que quieras)
      return () => clearTimeout(timer);
    }
  }, [step]);
  
  

  const ganador = evaluarRespuestas(respuestas); // devuelve objeto { key, nombre, scores }

  const resultadomore = contenidoResultado.find(
    (item) => item.respuestacalc === ganador.key

  );
  /*const ganador = evaluarRespuestas(respuestas);
  const resultadomore = contenidoResultado.find(
    (item) => item.respuestacalc === ganador
  );


  const [question, setQuestion] = useState(Array(5).fill(null));

  const evaluacion = evaluarRespuestas(question);

  console.log("ver datos");
  console.log(ganador);
  console.log(resultadomore);
  console.log(contenidoResultado);
  console.log(contenidoResultado.tituloprincipal);
  const resultadoArray = Object.keys(resultadomore);
  console.log(resultadoArray);*/

  console.log("ver datos");
  console.log(ganador);
  console.log(resultadomore);
  console.log(contenidoResultado);
  console.log(contenidoResultado.tituloprincipal);

  return (
    <div className="container-fluid test-container d-flex flex-column align-items-center justify-content-center ">
        {/*<div className="p-md-auto p-3 test-container d-flex flex-column align-items-center justify-content-center min-vh-100">*/}
      {step === 0 ? (
        // Pantalla inicial
        <div className="d-flex flex-column justify-content-center align-items-center">
          <h1 className="tit-principal text-center">
            <span style={{color: "var(--color-principal)"}}>¿No sabes qué producto</span>{" "}
            <br/> es el que necesitas?
          </h1>
          <p style={{ color: "var(--color-texto-negro)", textAlign:'center', fontWeight:'600', width:'80%', fontSize: '1.3rem'}}>
            Con nuestro Test
            te ayudamos a elegir en menos de un minuto.
          </p>
          <p style={{ color: "var(--color-text-negro-light)", textAlign:'center', }}>
            Responde 5 preguntas y descubre la mejor opción para tu proyecto.
          </p>
          <div className="cont-btn-test">
            <button
                className="btn mt-3 btn btn-custom"
                onClick={() => setStep(1)}
            >
                Comenzar el test 
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                </svg>
            </button>
          </div>
          {/*<div>
            <Loading/>
          </div>*/}
        </div>
      ) : step <= preguntas.length ? (
        <div>
        {/* Preguntas*/}
        <div className="card p-4" style={{ borderRadius: "20px", border: 'none', background:'var(--color-secundario-blanco)', maxWidth: "750px"}}>
          
            {/* Círculos de progreso */}
            <div className="d-flex mb-3">
            {preguntas.map((_, i) => {
                const isActive = step - 1 === i;
                const isAnswered = respuestas[i];

                // Color de fondo según estado
                const backgroundColor = isActive
                ? "var(--color-principal-oscuro)"
                : isAnswered
                ? "var(--color-gray)"
                : "transparent";

                // Color de número según estado
                const textColor = isActive
                ? "white"
                : isAnswered
                ? "var(--color-texr-gris-dark)" // gris oscuro
                : "var(--color-gray)";

                // Color del borde
                const borderColor = isActive
                ? "var(--color-principal-oscuro)"
                : isAnswered
                ? "var(--color-gray)"
                : "var(--color-gray)";


                return (
                <div
                    key={i}
                    className="rounded-circle me-2 d-flex justify-content-center align-items-center"
                    style={{
                    width: "35px",
                    height: "35px",
                    border: `2px solid ${borderColor}`,
                    backgroundColor,
                    color: textColor,
                    fontSize: "14px",
                    fontWeight: "bold",
                    }}
                >
                    {i + 1}
                </div>
                );
            })}
            </div>



          {/* Pregunta */}
          <h2 className="tit-principal" style={{width: '100%'}}>{preguntas[step - 1].pregunta}</h2>
          <div className="mt-2">
            {preguntas[step - 1].opciones.map((opcion, idx) => (
              <div key={idx} className="form-check">
                <input
                  type="radio"
                  id={`op-${step}-${idx}`}
                  name={`preg-${step}`}
                  checked={respuestas[step - 1] === opcion}
                  onChange={() => handleSelect(step - 1, opcion)}
                  style={{
                    border: '3px solid gray'
                  }}
                  className="form-check-input"
                />
                <label style={{color:'black'}} htmlFor={`op-${step}-${idx}`} className="form-check-label">
                  {opcion}
                </label>
              </div>
            ))}
          </div>
        </div>
        <div className="container-fluid pt-3">
            <div className="row">
                <div className="col-md-7 col-12">
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <button className="btn me-3 link-test" onClick={handleRestart} >
                            <strong><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
                            </svg> Volver a empezar</strong>
                        </button>
                        
                        <div style={{height:'17px', width: '1.5px', background: 'black'}}></div>
                        <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn ms-3 link-test">
                            <strong><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                            </svg>
                            Hablar con un asesor</strong>
                        </a>
                    </div>
                </div>
                <div className="col-md-5 col-12 justify-content-end">
                  <div className="d-flex justify-content-end align-items- align-content-center">
                            {step > 1 && (
                                <button
                                className="btn btn-custom me-2 p-3"
                                style={{background: 'white', color:'black'}}
                                onClick={() => setStep(step - 1)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                                    </svg>
                                    Atrás
                                </button>
                            )}
                        
                        
                        <button
                            className="btn btn-custom p-3"
                            onClick={() => setStep(step + 1)}
                            disabled={!respuestas[step - 1]}
                        >
                            {step === preguntas.length ? (
                                <>
                                    Ver resultado 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                    </svg>
                                </>
                                ) : (
                                <>
                                    Siguiente 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                                    </svg>
                                </>
                                )}
                        </button>
                    </div>
                </div>

            </div>
        </div>
        
        </div>

     
      ) : (
  <div
    style={{ minHeight: "200px", width: '100%'}}
  >
    {loadingResultados ? (
      <div>
        <Loading />
      </div> 
    ) : (
      // Resultados con animación
      <div className="d-flex justify-content-center align-items-center">
        {/**style={{ borderRadius: "20px", maxWidth: "600px" }} */}
      <div className="">
        {resultadomore && (
              
              <div className="container-fluid">
                <div className="row">
                <div className="col-lg-6 col-md-6 col-12 mb-lg-auto mb-md-5 mb-5">
                  <img
                  src={resultadomore.imgrespuesta}
                  alt={resultadomore.tituloprincipal}
                  className="img-fluid rounded"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-12 px-lg-3 px-auto">
                  <div className='c-serv'>
                    <p className="txt1-cserv">{resultadomore.texto1}</p>
                    <h2 className="tit-principal" style={{}}>{resultadomore.tituloprincipal}</h2>
                    <p className="sub-cserv">{resultadomore.subtitulo}</p>
                    
                    <p>{resultadomore.txtclick}{resultadomore.texto2}</p>
                    {/*<img
                      src={resultadomore.imgrespuesta}
                      alt={resultadomore.tituloprincipal}
                      className="img-fluid rounded"
                    />*/}
                    </div>
                  </div>
                </div>
              </div>
            )}
          {/*<div className="container-fluid">
            <div className="row">
                
                <div className="col-md-6 col-12">
                    
                </div>
                <div className="col-md-6 col-12">
                    <div className="d-flex flex-row justify-content-center">
                        
                        <button className="btn btn-custom p-3" onClick={handleWhatsApp}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                            </svg>
                            Realizar pedido
                        </button>
                        
                    </div>
                </div>
            </div>
            </div>*/}
        </div>
        </div>
    )}
  </div>
)
        }
    </div>
  );
}

export default Test;
